import React, {useEffect, useState} from 'react';
import { TextField, Button, CircularProgress, FormControl, InputLabel, Select ,MenuItem, Grid } from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { axiosWithAuth } from '../utils/axiosWithAuth';
import Role from './Assets/Role'
import { ERROR, LOADING, LOADING_OFF } from '../store/actions/UserAction';
import styled from 'styled-components';
// import { ERROR, LOADING } from '../store/actions/userActions';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import { lightGreen } from '@material-ui/core/colors';
const greenTheme = createMuiTheme({ palette: { primary: lightGreen } })

const initialUser = {
    fname: '',
    mname: '',
    points: '',
    usernamee: '',
    roles: '',
}

  const Form = styled.form`
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  background: white;
  padding: 20% 0;
  margin-top: 3rem;
  /* margin-top: 25%; */
  margin-bottom: 6rem;
  @media (min-width: ${props => props.theme.mobileBreakpoint}){
      max-width: 90%;
      margin-top: 5rem;
      border: 1px grey solid;
      border-radius: 1.4%;
      padding: 2% 0;
  }
  @media (min-width: ${props => props.theme.tabletBreakpoint}){
      border: 1px grey solid;
      margin-top: 6rem;
      border-radius: 1.4%;
      max-width: 60%;
  }
`

const StyledTF = styled(TextField)`
  width: 80%;
`

const StyledFC = styled(FormControl)`
  width: 80%;
`

const EditUser = (props) => {
    const { id } = useParams()
    const [user, setUser] = useState(initialUser)
    let history = useHistory()
    let dispatch = useDispatch()
    let roles = useSelector(state => state.userInfo)

    const inputHandler = (e) => {
        e.preventDefault()
        setUser({...user, [e.target.name]: e.target.value})
    }

    const roleHandler = (e) => {
        let userRole = Role.filter(r => r.role.name === e.target.value)
        setUser({...user, [e.target.name] : userRole}) 
    }

    const submitHandler = (e) => {
        e.preventDefault()
        dispatch({type: ERROR, payload: ''})
        if (!user.points || user.points < 0) {
            dispatch({type: ERROR, payload: "Points cannot be less than 0"})
            return
        } else if (!user.points || user.points > 999) {
            dispatch({type: ERROR, payload: "Points cannot be greater than 999"})
            return
        }
        dispatch({type: LOADING, payload: ''})
        const points = {'points': user.points}
        axiosWithAuth()
            .patch(`/users/user/${id}`, points)
            .then(res => {
                dispatch({type: ERROR, payload: 'SUCCESS'})
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
            })
            .finally(()=>{
                dispatch({type: LOADING_OFF, payload: ''})
                history.push('/', [roles])
            })
    }
    const roleSubmitHandler = (e) => {
        e.preventDefault()
        dispatch({type: ERROR, payload: ''})
        dispatch({type: LOADING, payload: ''})
        if (roles && roles.roles[0].role.name === "ADMIN"){
            axiosWithAuth()
                .post(`users/user/${id}/${user.roles[0].role.name}`, {})
                .then(res => {
                    dispatch({type: ERROR, payload: `${user.fname}'s role has been successfully changed to ${user.roles[0].role.name}`})
                })
                .catch(err => {
                    dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
                })
                .finally(()=>{
                    dispatch({type: LOADING_OFF, payload: ''})
                    // history.push('/', [roles])
                })
        }
    }
    

    const cancelHandler = (e) => {
        e.preventDefault()
        setUser(initialUser)
        dispatch({type: ERROR, payload: ''})
        history.push('/')
    }

    const deleteHandler = (e) => {
        e.preventDefault()
        if (!window.confirm("Are you sure you want to delete this user")) {
            return
        }
        dispatch({type: ERROR, payload: ''})
        axiosWithAuth()
            .delete(`users/user/${id}`, )
            .then(res => {
                dispatch({type: ERROR, payload: 'SUCCESS'})
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
            })
        history.push('/')
    }


    useEffect(()=> {
        axiosWithAuth()
            .get(`/users/user/${id}`)
            .then(res => {
                setUser(res.data)
                dispatch({type: ERROR, payload: ''})
            })
            .catch(err => {
                dispatch({type: ERROR, payload: "That wasn't suppose to happen, try again"})
                history.push('/')
            })
    },[])

    useEffect(() => {
        if (roles && roles.roles[0].role.name === "MEMBER") {
            history.push('/')
        }
    },[roles])

    return (
        <>
            {!user.roles ? <CircularProgress /> : 
            <>
                <Form onSubmit={submitHandler}>
                <Grid container direction={"column"} spacing={2}>
                    <Grid item>
                        <h4>EDIT USER</h4>
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Username'
                            variant="filled"
                            name='username'
                            value={user.username}
                            // onChange={inputHandler}
                            type='text'
                            disabled='true'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='First Name'
                            variant="filled"
                            name='fname'
                            value={user.fname}
                            // onChange={inputHandler}
                            type='text'
                            disabled='true'
                        />
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Last Name'
                            variant="filled"
                            name='lname'
                            value={user.lname}
                            // onChange={inputHandler}
                            type='text'
                            disabled='true'
                        />
                    </Grid>
                    <Grid item>
                        <StyledFC variant="filled">
                            <InputLabel>Role</InputLabel>
                            <Select
                                value={user.roles[0].role.name}
                                name='roles'
                                onChange={roleHandler}
                                label="Role"
                                disabled={roles && roles.roles[0].role.name === "ADMIN" ? '' : 'true'}
                            >
                            {Role.map(r => {
                                return <MenuItem value={r.role.name}>{r.role.name}</MenuItem>
                            })}
                            </Select>
                        </StyledFC>
                    </Grid>
                    <Grid item>
                        <StyledTF
                            label='Points'
                            variant="filled"
                            value={user.points}
                            name='points'
                            // value={campaign.goal}
                            onChange={inputHandler}
                            type='number'
                        />
                    </Grid>
                    <Grid item>
                        <Grid container direction={"row"} spacing={2} justify={"center"}>
                            <MuiThemeProvider theme={greenTheme}>
                                <Grid item>
                                    <Button variant="contained" color="primary" onClick={cancelHandler}>
                                        Cancel
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="secondary" hidden={roles && roles.roles[0].role.name === "ADMIN" ? '' : 'true'} onClick={deleteHandler}>
                                        Delete
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button variant="contained" color="primary" hidden={roles && roles.roles[0].role.name === "ADMIN" ? '' : 'true'} onClick={roleSubmitHandler}>
                                        Update Role
                                    </Button>
                                </Grid>
                                <Grid item>
                                    <Button type='submit' variant="contained" color="primary">
                                        Save
                                    </Button>
                                </Grid>
                                
                            </MuiThemeProvider>
                        </Grid>
                    </Grid>
                    </Grid>
                </Form>
            </>}
        </>
    )
}

export default EditUser